import Component from '@glimmer/component'
import { capitalize } from '@ember/string'
import { colors } from '@colors'
import { t } from 'ember-intl'
import SeriesBar from 'district-ui-client/components/primitives/series-bar/component'
import type { SeriesBarOptions } from 'highcharts'
import type { StadiumEventsData } from 'district-ui-client/utils/student-events/fetchers/stadium-events'

interface Signature {
  Args: {
    data: StadiumEventsData
  }
}
const eventTypes = ['spelling', 'grammar', 'vocabulary', 'usage'] as const

export class StadiumEventsDashboardChart extends Component<Signature> {
  get stadiumEvents() {
    return this.args.data
  }

  get categories() {
    return eventTypes.map((eventType) => capitalize(eventType))
  }

  get rows(): SeriesBarOptions[] {
    const { stadiumEvents } = this

    const data = eventTypes.map((eventType) => {
      return stadiumEvents[eventType]
    })

    return [{ data, type: 'bar' }]
  }

  get colours() {
    return [colors.oceanyBlue300, colors.oceanyBlue400, colors.juicyOrange300, colors.purplyPink300]
  }

  <template>
    <div class="flex h-full flex-col" data-test-stadium-events>
      <div data-test-dashboard-subtitle class="flex justify-between gap-4 text-xs">
        <span>
          {{t "reporting.charts.dashboard.stadiumEvents.overallEventsCompleted"}}
        </span>
      </div>
      <SeriesBar
        @data={{this.rows}}
        @categories={{this.categories}}
        @colours={{this.colours}}
        @colorByPoint={{true}}
        @barPadding={{0}}
        @groupPadding={{0.15}}
        @yAxisLabel="Number of plays"
      />
    </div>
  </template>
}
export default StadiumEventsDashboardChart
